<p-table [value]="form().controls" size="small" >
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 1rem">#</th>
            <th style="min-width: 20rem">Operazione</th>
            @if(isProduction()){<th style="min-width: 12rem">Macchina</th>}
            <th style="min-width: 8rem">T. Lav. Previsto</th>
            <th style="min-width: 8rem">T. Attr. Previsto</th>
            <th style="width: 3rem">Q.tà</th>
            @if(isConsuntivo()){
            <th style="min-width: 8rem">T. Lav. Effettivo</th>
            <th style="min-width: 8rem">T. Attr. Effettivo</th>
            }
            @if(isProduction()){<th style="min-width: 12rem">Operatore</th>}
            <!--@if(isProduction()){<th style="min-width: 12rem">Fornitore</th>}-->
            <th style="width: 100%">Info</th>
            @if(showCost()){<th style="min-width: 6rem; text-align: right;">Costo</th>}
            @if(!isFormDisabled()){<th style="width: 1rem"></th>}
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowGroup let-i="rowIndex">
        <tr [formGroup]="$any(rowGroup)">
            <td class="p-0"><spike-field-text formControlName="sequenzaId" [readOnly]="true"></spike-field-text></td>
            <!--<td class="p-0"><spike-field-text formControlName="shortDescription" placeholder="Titolo"></spike-field-text></td>-->
            <td class="p-0">
              <spike-field-select [initialValue]="organizationStore.getOperation(rowGroup.get('operationTypeId').value)()" formControlName="operationTypeId" selectKey="operationId" selectValue="shortDescription" listTitle="Seleziona operazione" detailTitle="Dettaglio operazione">
                    <ng-template #list>
                        <spike-organization-list #listRef 
                            [modelApi]="operationModelApi"
                            [entityApi]="operationApi"
                            [etiquetteApi]="operationEtiquetteApi"
                            entityKey="operationId">
                        </spike-organization-list>
                    </ng-template>
                </spike-field-select>
            </td>       
            @if(isProduction()){
            <td class="p-0">
              <spike-field-select [readOnly]="!rowGroup.get('operationTypeId').value" [initialValue]="organizationStore.getMachine(rowGroup.get('machineId').value)()" formControlName="machineId" selectKey="machineId" selectValue="shortDescription" listTitle="Seleziona macchina" detailTitle="Dettaglio macchina">
                    <ng-template #list>
                        <spike-organization-list #listRef 
                            [modelApi]="machineModelApi"
                            [entityApi]="machineApi"
                            [etiquetteApi]="machineEtiquetteApi"
                            [operationId]="rowGroup.get('operationTypeId').value"
                            entityKey="machineId">
                        </spike-organization-list>
                    </ng-template>
                </spike-field-select>
            </td>       
            }
            <td class="p-0"><spike-field-number formControlName="workingTime" [readOnly]="isConsuntivo()"></spike-field-number></td>
            <td class="p-0"><spike-field-number formControlName="equipmentTime" [readOnly]="isConsuntivo()"></spike-field-number></td>
            <td class="p-0"><spike-field-number formControlName="quantity" placeholder="Q.tà" [readOnly]="isConsuntivo()"></spike-field-number></td>
            @if(isConsuntivo()){
            <td class="p-0"><spike-field-number formControlName="finalWorkingTime" [readOnly]="!isConsuntivo()"></spike-field-number></td>
            <td class="p-0"><spike-field-number formControlName="finalEquipmentTime" [readOnly]="!isConsuntivo()"></spike-field-number></td>
            }
            @if(isProduction()){
            <td class="p-0">
              <spike-field-select [readOnly]="!rowGroup.get('operationTypeId').value" [initialValue]="organizationStore.getEmployee(rowGroup.get('employeeId').value)()" formControlName="employeeId" selectKey="employeeId" selectValue="shortDescription" listTitle="Seleziona operatore" detailTitle="Dettaglio operatore">
                    <ng-template #list>
                        <spike-organization-list #listRef
                            [modelApi]="employeeModelApi"
                            [entityApi]="employeeApi"
                            [etiquetteApi]="employeeEtiquetteApi"
                            [operationId]="rowGroup.get('operationTypeId').value"
                            entityKey="employeeId">
                        </spike-organization-list>
                    </ng-template>
                </spike-field-select>
            </td>
            }
            <!--
            @if(isProduction()){
            <td class="p-0">
              <spike-field-select [readOnly]="isInternal(rowGroup)" [initialValue]="organizationStore.getSupplier(rowGroup.get('supplierId').value)()" formControlName="supplierId" selectKey="supplierId" selectValue="shortDescription" listTitle="Seleziona fornitore" detailTitle="Dettaglio fornitore">
                    <ng-template #list>
                        <spike-organization-list #listRef
                            [modelApi]="supplierModelApi"
                            [entityApi]="supplierApi"
                            [etiquetteApi]="supplierEtiquetteApi"
                            entityKey="supplierId">
                        </spike-organization-list>
                    </ng-template>
                </spike-field-select>
            </td>
            }
            -->
            <td class="p-0"><spike-field-text formControlName="description" placeholder="Info"></spike-field-text></td>
            @if(showCost()){<td class="p-0"><spike-field-number formControlName ="cost" [readOnly]="isInternal(rowGroup)" mode="currency" currency="EUR" textAlign="text-right"></spike-field-number></td>}
            @if(!isFormDisabled() && (!isConsuntivo()||(isConsuntivo()&&rowGroup.get('workingTime').value==0))){
            <td  class="p-0" >
                <div class="cursor-pointer" (click)="deleteRow.emit(i)"><i class="pi pi-trash" style="color: var(--p-button-text-danger-color)"></i></div>
            </td>
            }
        </tr>
    </ng-template>

    <ng-template pTemplate="summary">
            @if(!isFormDisabled()){
            <div class="flex">
            <div class="flex justify-content-end">
                <p-button 
                    label="Aggiungi Operazione interna" 
                    icon="pi pi-plus" 
                    [text]="true" 
                    size="small"
                    (onClick)="addInternalRow.emit()">
                </p-button>
            </div>
            <!--
            <div class="flex justify-content-end">
                <p-button 
                    label="Aggiungi Lavorazione esterna" 
                    icon="pi pi-plus" 
                    [text]="true" 
                    size="small"
                    (onClick)="addExternalRow.emit()">
                </p-button>
            </div>-->
            </div>
        }
    </ng-template>
</p-table>